// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../../components/Button';
import LabImage from '../../../../assets/images/pic_lab.png';

const otherS = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  `,
  Row: styled.div`
    display: flex;
    align-items: center;
  `,
  InformationContainer: styled.div`
    width: 434px;
    display: flex;
    flex-direction: column;
  `,
  Title: styled.div`
    font-weight: 700;
    font-size: 24px;
    color: #434343;
  `,
  Overview: styled.div`
    margin-top: 18px;
    font: 16px Noto Sans TC;
    color: #434343;
  `,
  LabImage: styled.img.attrs({ src: LabImage, alt: 'lab-image'})`
    margin-left: 53px;
  `,
  Button: styled(Button)`
    margin-top: 26px;
    box-shadow: 0px 1px 4px 0px #00000040;
    width: 142px;

    & + & {
      margin-left: 25px;
    }
  `
};

export const S = {
  ...otherS
}
